import {
  Avatar,
  Table,
  Pagination,
  Flex,
  Popover,
  Input,
  Select,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  deleteCompanyById,
  getAddressList,
  getCompaniesList,
} from "../../api/companyApi";
import { deleteNotification } from "../../utils/useNotification";
import TableDeleteButton from "../common/TableDeleteButton";
import TableEditButton from "../common/TableEditButton";
import styled from "styled-components";
import AreYouSureModal from "../common/AreYouSureModal";

const CompaniesTable = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [tableData, setTableData] = useState<any>();
  //for pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [totalPages, setTotalPages] = useState(1);
  //for delete modal
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [itemToDeleteId, setitemToDeleteId] = useState<any>();
  //for department select
  const [selectData, setSelectData] = useState<any>();
  const [selectedAddress, setSelectedAddress] = useState<any>();
  //for sort
  const [sort, setSort] = useState<any>("");
  //for search
  const [searchedName, setSearchedName] = useState<any>();
  const [searchedCode, setSearchedCode] = useState<any>();

  const getTableData = async () => {
    try {
      const { data }: any = await getCompaniesList({
        pageNumber: page,
        limit: limit,
        sort,
        address: selectedAddress,
        code: searchedCode,
        name: searchedName,
      });
      setTableData(data?.data);
      setPage(data?.meta?.page);
      setLimit(data?.meta?.limit);
      setTotalPages(data?.meta?.totalPages);
    } catch (error) {}
  };

  const getAddresses = async () => {
    try {
      const { data }: any = await getAddressList();
      setSelectData(data);
    } catch (error) {}
  };

  useEffect(() => {
    if (page) {
      navigate(`?page=${page}&limit=${limit}`, { replace: true });
      getTableData();
    }
  }, [page, sort, selectedAddress, searchedCode, searchedName]);

  useEffect(() => {
    getAddresses();
  }, []);

  const handleDeleteClick = async (id: any) => {
    try {
      const { data }: any = await deleteCompanyById({ id });
      deleteNotification(data?.success);
      getTableData();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <TableWrapper>
      <div style={{ overflowX: "auto", width: "100%" }}>
          <Table
            style={{
              borderCollapse: "separate",
              borderSpacing: "0px 4px",
            }}
            highlightOnHover
            verticalSpacing="sm"
            withRowBorders={false}
          >
            <Table.Thead>
              <Table.Tr>
                <StyledTableTh style={{ width: "25%" }}>
                  <Flex gap={4}>
                    <Flex
                      gap={4}
                      style={{
                        cursor: "pointer",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setSort((prev: string) =>
                          prev === "desc" ? "asc" : "desc"
                        );
                      }}
                    >
                      <div>Şirket İsmi</div>
                      {sort === "desc" ? (
                        <Avatar src={"/assets/ascSortIcon.png"} size={16} />
                      ) : (
                        <Avatar src={"/assets/descSortIcon.png"} size={16} />
                      )}
                    </Flex>
                    <Popover position="right" shadow="md">
                      <Popover.Target>
                        <div style={{ width: "max-content" }}>
                          <Avatar
                            style={{
                              cursor: "pointer",
                            }}
                            src={"/assets/searchIcon.png"}
                            size={16}
                          />
                        </div>
                      </Popover.Target>
                      <Popover.Dropdown>
                        <Input
                          value={searchedName}
                          onChange={(event) => {
                            {
                              setPage(1);
                              setSearchedName(event.currentTarget.value);
                            }
                          }}
                        />
                      </Popover.Dropdown>
                    </Popover>
                  </Flex>
                </StyledTableTh>
                <StyledTableTh style={{ width: "25%" }}>
                  <Flex gap={4}>
                    <Flex
                      gap={4}
                      style={{
                        alignItems: "center",
                      }}
                    >
                      <div>Şirket Kodu</div>
                    </Flex>
                    <Popover position="right" shadow="md">
                      <Popover.Target>
                        <div style={{ width: "max-content" }}>
                          <Avatar
                            style={{
                              cursor: "pointer",
                            }}
                            src={"/assets/searchIcon.png"}
                            size={16}
                          />
                        </div>
                      </Popover.Target>
                      <Popover.Dropdown>
                        <Input
                          value={searchedCode}
                          onChange={(event) => {
                            {
                              setPage(1);
                              setSearchedCode(event.currentTarget.value);
                            }
                          }}
                        />
                      </Popover.Dropdown>
                    </Popover>
                  </Flex>
                </StyledTableTh>
                <StyledTableTh style={{ width: "15%" }}>
                  <Flex>
                    <StyledSelect
                      variant="unstyled"
                      placeholder="Adres"
                      data={selectData}
                      onChange={(e) => {
                        setSelectedAddress(e);
                        setPage(1);
                      }}
                    />
                  </Flex>
                </StyledTableTh>

                <StyledTableTh style={{ width: "10%" }}></StyledTableTh>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {tableData?.map((company: any) => (
                <StyledTableTr
                  onClick={() => {
                    navigate(`${location?.pathname}/detail/${company?._id}`);
                  }}
                  bg={"#F9F9F9"}
                  key={company?._id}
                  style={{
                    color: "#1D1B20",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                >
                  <Table.Td style={{ width: "30%" }}>{company?.name}</Table.Td>
                  <Table.Td style={{ width: "25%" }}>{company?.code}</Table.Td>
                  <Table.Td style={{ width: "25%" }}>
                    {company?.address}
                  </Table.Td>

                  <Table.Td style={{ width: "10%" }}>
                    <Flex justify={"start"} gap={12}>
                      <TableEditButton
                        onClick={(e: any) => {
                          e.stopPropagation();
                          navigate(
                            `${location?.pathname}/edit/${company?._id}`
                          );
                        }}
                      />
                      <TableDeleteButton
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setitemToDeleteId(company?._id);
                          setOpenDeleteModal(true);
                        }}
                      />
                    </Flex>
                  </Table.Td>
                </StyledTableTr>
              ))}
            </Table.Tbody>
          </Table>
        </div>
      <Flex justify="center" style={{ position: "absolute", bottom: "20px", left: "50%", transform: "translateX(-50%)" }}>
        <Pagination
          total={totalPages}
          value={page}
          onChange={setPage}
          withEdges
          color="#5C26FF"
          radius="xl"
        />
      </Flex>
      
      <AreYouSureModal
        opened={openDeleteModal}
        setOpened={setOpenDeleteModal}
        proccessFunc={() => handleDeleteClick(itemToDeleteId)}
        title="Şirket Sil"
        text="Bu şirketi silmek istediğinizden emin misiniz?"
        confirmButtonText="Sil"
        cancelButtonText="Vazgeç"
      />
    </TableWrapper>
  );
};

export default CompaniesTable;

const StyledTableTh = styled(Table.Th)`
  color: #4c4c4c;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

const StyledTableTr = styled(Table.Tr)`
  cursor: pointer;
  &:hover {
    background: #f1f3f5 !important;
  }
`;

const StyledSelect = styled(Select)`
  .mantine-Input-input {
    width: 100% !important;
    &::placeholder {
      color: #4c4c4c;
    }
  }
`;

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  justify-content: space-between;
`;
